import React from 'react'
import * as yup from 'yup'

import { FormattedMessage } from '@divvy-web/i18n'

const bankNamePattern = /^[a-zA-Z\d]+[\da-zA-Z.'’ —:&-]*$/i
const bankNameValidationErrorMessage = (
  <FormattedMessage
    defaultMessage='Please enter a valid bank name greater than 2 characters'
    id='sputnik.addManualBankAccountDrawerValidationSchema__u1kyIw'
  />
)

export const addManualBankAccountDrawerValidationSchema = yup.object().shape({
  accountHolderName: yup.string().required(() => (
    <FormattedMessage
      defaultMessage='Account holder name is required'
      id='sputnik.addManualBankAccountDrawerValidationSchema__XhQTRm'
    />
  )),
  bankName: yup
    .string()
    .required(() => bankNameValidationErrorMessage)
    .min(3, () => bankNameValidationErrorMessage)
    .matches(bankNamePattern, () => bankNameValidationErrorMessage),
  routingNumber: yup
    .string()
    .required(() => (
      <FormattedMessage
        defaultMessage='Routing number is required'
        id='sputnik.addManualBankAccountDrawerValidationSchema__e4+sh+'
      />
    ))
    .matches(/^[0-9]*$/, () => (
      <FormattedMessage
        defaultMessage='Please enter a valid routing number'
        id='sputnik.addManualBankAccountDrawerValidationSchema__u6xKot'
      />
    ))
    .length(9, () => (
      <FormattedMessage
        defaultMessage='Routing number must be 9 digits'
        id='sputnik.addManualBankAccountDrawerValidationSchema__5VzV0t'
      />
    ))
    .test(
      'cannotBeAccountNumber',
      () => (
        <FormattedMessage
          defaultMessage='Routing number cannot be the same as account number'
          id='sputnik.addManualBankAccountDrawerValidationSchema__AfdMP9'
        />
      ),
      (value, { parent }) => {
        if (!value || !parent.accountNumber) {
          return true
        }

        return value !== parent.accountNumber
      },
    ),
  confirmRoutingNumber: yup.string().when('routingNumber', ([routingNumber], schema) =>
    schema.equals([routingNumber], () => (
      <FormattedMessage
        defaultMessage='Routing numbers must match'
        id='sputnik.addManualBankAccountDrawerValidationSchema__/n583V'
      />
    )),
  ),
  accountNumber: yup
    .string()
    .required(() => (
      <FormattedMessage
        defaultMessage='Account number is required'
        id='sputnik.addManualBankAccountDrawerValidationSchema__5iAoBq'
      />
    ))
    .min(4, () => (
      <FormattedMessage
        defaultMessage='Account number should be at least 4 digits long'
        id='sputnik.addManualBankAccountDrawerValidationSchema__IA28ba'
      />
    ))
    .max(17, () => (
      <FormattedMessage
        defaultMessage='Account number should be at most 17 digits'
        id='sputnik.addManualBankAccountDrawerValidationSchema__/SgL8P'
      />
    ))
    .test(
      'cannotBeRoutingNumber',
      () => (
        <FormattedMessage
          defaultMessage='Account number cannot be the same as routing number'
          id='sputnik.addManualBankAccountDrawerValidationSchema__ChsAYg'
        />
      ),
      (value, { parent }) => {
        if (!value || !parent.routingNumber) {
          return true
        }

        return value !== parent.routingNumber
      },
    ),
  confirmAccountNumber: yup.string().when('accountNumber', ([accountNumber], schema) =>
    schema.equals([accountNumber], () => (
      <FormattedMessage
        defaultMessage='Account numbers must match'
        id='sputnik.addManualBankAccountDrawerValidationSchema__5rj3gK'
      />
    )),
  ),
})

export type AddManualBankAccountDrawerValidationSchema = yup.InferType<
  typeof addManualBankAccountDrawerValidationSchema
>
